export const arrayDuplicates = (array) => {
    const duplicates = array.filter((item, index) => array.indexOf(item) !== index);
    return Array.from(new Set(duplicates));
};
